import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import apiConfig from '../../apiConfig';



export const fetchShopLocationInfo = createAsyncThunk("fetchShopLocationInfo", async () => {
    const res = await fetch(`${apiConfig.apiBasePath}getShopLocations`);
    return res?.json();
 });

 const initialState = {
    value: fetchShopLocationInfo()
}


 const ShoplocationSlice = createSlice({
    name: 'Shoplocation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchShopLocationInfo.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(fetchShopLocationInfo.fulfilled, (state, action) => {
          state.status = 'idle';
          state.value = action.payload;
        })
        .addCase(fetchShopLocationInfo.rejected, (state) => {
          state.status = 'failed';
        });
    },
  });
  
  export const {} = ShoplocationSlice.actions
  
  export default ShoplocationSlice.reducer
